export const ar = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'الرئيسية',
  forYou: 'لك',
  myList: 'المفضلة',
  profile: 'الملف الشخصي',
  userProfile: 'ملف المستخدم',

  // Authentication
  signIn: 'تسجيل الدخول',
  signUp: 'إنشاء حساب',
  signOut: 'تسجيل الخروج',
  signInWithApple: 'تسجيل الدخول بواسطة Apple',
  signUpWithApple: 'إنشاء حساب بواسطة Apple',
  signInWithGoogle: 'تسجيل الدخول بواسطة Google',
  signUpWithGoogle: 'إنشاء حساب بواسطة Google',
  appleSignInFailed: 'فشل تسجيل الدخول بواسطة Apple. يرجى المحاولة مرة أخرى.',
  appleAuthExpired: 'انتهت صلاحية رمز Apple',
  appleAuthRetrying: 'جاري إعادة المحاولة...',
  appleAuthRetryFailed: 'فشل تسجيل الدخول بواسطة Apple. يرجى المحاولة مرة أخرى.',
  appleAuthMaxRetriesReached: 'محاولات كثيرة جداً. يرجى المحاولة لاحقاً.',
  appleSignInCancelled: 'تم إلغاء تسجيل الدخول بواسطة Apple.',
  appleAccountAlreadyExists: 'يوجد حساب بهذا المعرف Apple بالفعل. يرجى تسجيل الدخول.',
  appleAccountNotFound: 'لم يتم العثور على حساب بهذا المعرف Apple. يرجى إنشاء حساب أولاً.',
  googleSignInFailed: 'فشل تسجيل الدخول بواسطة Google. يرجى المحاولة مرة أخرى.',
  googleAuthRetrying: 'جاري إعادة المحاولة...',
  googleAuthMaxRetriesReached: 'محاولات كثيرة جداً. يرجى المحاولة لاحقاً.',
  or: 'أو',
  email: 'البريد الإلكتروني',
  emailOrPhone: 'البريد الإلكتروني أو الهاتف',
  enterEmail: 'أدخل بريدك الإلكتروني',
  enterEmailOrPhone: 'أدخل بريدك الإلكتروني أو رقم هاتفك',
  emailOrPhonePlaceholder: 'email@example.com أو +33612345678',
  signInRequired: 'تسجيل الدخول مطلوب',
  toWatchThisEpisode: 'لمشاهدة هذه الحلقة',
  toAddEpisodeToFavorites: 'لإضافة هذه الحلقة إلى المفضلة',
  pleaseSignInToWatch: 'يرجى تسجيل الدخول لمشاهدة هذه الحلقة',
  pleaseSignInToAddFavorite: 'يرجى تسجيل الدخول لإضافة هذه الحلقة إلى المفضلة',
  pleaseSignInToAddSerieFavorite: 'يرجى تسجيل الدخول لإضافة هذا المسلسل إلى المفضلة',
  pleaseSignInToSubscribe: 'يرجى تسجيل الدخول للاشتراك',
  pleaseSignInToAccessRewards: 'يرجى تسجيل الدخول للوصول إلى جميع الميزات وتتبع مكافآتك.',
  subscriptionRequired: 'الاشتراك مطلوب',
  episodeRequiresPremium: 'هذه الحلقة تتطلب اشتراك بريميوم',

  // Force update
  updateRequired: 'التحديث مطلوب',
  currentVersion: 'الإصدار الحالي',
  requiredVersion: 'الإصدار المطلوب',
  updateNow: 'تحديث الآن',
  appCannotBeUsedWithoutUpdate: 'لا يمكن استخدام التطبيق بدون تحديث',
  forceUpdateDefaultMessage: 'يتوفر إصدار جديد من التطبيق. يرجى التحديث لمواصلة استخدام التطبيق.',

  // Recommended update
  updateAvailable: 'تحديث متاح',
  recommendedVersion: 'الإصدار الموصى به',
  updateButton: 'تحديث',
  laterButton: 'لاحقاً',
  updateWillBeShownAgainIn24Hours: 'سيتم عرض هذا التحديث مرة أخرى خلال 24 ساعة',
  recommendedUpdateMessage: 'يتوفر إصدار جديد من التطبيق مع تحسينات وميزات جديدة. نوصي بالتحديث للحصول على أفضل تجربة.',

  // Errors
  error: 'خطأ',
  pleaseFillAllFields: 'يرجى ملء جميع الحقول',
  failedToCreateAccount: 'فشل في إنشاء الحساب',
  invalidCredentials: 'بيانات الاعتماد غير صالحة',
  accountDisabled: 'تم تعطيل هذا الحساب',
  emailAlreadyExists: 'هذا البريد الإلكتروني مستخدم بالفعل من قبل حساب آخر',
  phoneAlreadyExists: 'هذا الرقم الهاتفي مستخدم بالفعل من قبل حساب آخر',
  invalidEmailFormat: 'يرجى إدخال عنوان بريد إلكتروني صالح',
  invalidPhoneFormat: 'يرجى إدخال رقم هاتف صالح',
  accountMergeNotSupported: 'يوجد حساب بالفعل بهذا البريد الإلكتروني. يرجى تسجيل الدخول باستخدام طريقة تسجيل الدخول الأصلية.',

  // Content
  searchDramas: 'البحث عن المسلسلات...',
  noResultsFound: 'لم يتم العثور على نتائج لـ "{query}"',
  searchResultsOne: 'نتيجة واحدة لـ "{query}"',
  searchResultsMany: '{count} نتائج لـ "{query}"',
  allSeries: 'جميع المسلسلات',
  topCharts: 'أفضل المسلسلات',
  recommendedForYou: 'موصى به لك',
  basedOnPreferences: 'بناءً على تفضيلاتك',
  continueWatching: 'متابعة المشاهدة',
  resumeWatching: 'استئناف المشاهدة',
  similarToWatched: 'مشابه لما شاهدته',
  trendingSearches: 'عمليات البحث الرائجة',
  noSeriesInProgress: 'لا توجد مسلسلات قيد المشاهدة',
  startWatchingToSee: 'ابدأ بمشاهدة مسلسل لرؤيته هنا',
  noContentAvailable: 'لا يوجد محتوى متاح',
  checkSupabaseConfig: 'يرجى التحقق من إعدادات Supabase',

  // Series and episodes
  seasons: 'المواسم',
  season: 'الموسم',
  episodes: 'الحلقات',
  synopsis: 'الملخص',
  episode: 'الحلقة',
  play: 'تشغيل',
  swipeToSeeMore: 'اسحب لمشاهدة المزيد',
  myListAction: 'المفضلة',
  addToMyList: 'إضافة إلى المفضلة',
  removeFromMyList: 'إزالة من المفضلة',
  popular: 'شائع',
  new: 'جديد',
  trending: 'رائج',
  highlight: 'مميز',
  free: 'مجاني',
  premium: 'بريميوم',
  premiumEpisode: 'حلقة بريميوم',
  signInToUnlock: 'سجل الدخول للفتح',
  subscribeToWatch: 'اشترك للمشاهدة',

  // Profile
  subscribeToPremium: 'الترقية إلى بريميوم',
  subscribeWithDCB: 'الترقية إلى بريميوم عبر الدفع بالهاتف',
  dcbSubscribeModalTitle: 'اشتراك عبر الدفع بالهاتف',
  dcbSubscribeLoading: 'جاري تحضير الدفع...',
  dcbSubscribeError: 'تعذر تحميل صفحة الدفع.',
  dcbSubscribeRetry: 'إعادة المحاولة',
  restorePurchases: 'استعادة المشتريات',
  purchaseProcessing: 'جاري المعالجة...',
  subscriptionActivated: 'تم تفعيل الاشتراك بنجاح!',
  webPaymentUnavailable: 'الدفع عبر الويب غير متاح حالياً. يرجى المحاولة لاحقاً.',
  paymentInitializing: 'نظام الدفع قيد التهيئة. يرجى المحاولة مرة أخرى بعد بضع ثوانٍ.',
  loadingOffers: 'جاري تحميل العروض...',
  purchasesRestored: 'تم استعادة اشتراكك بنجاح! لديك الآن حق الوصول إلى جميع المحتوى المميز.',
  noPurchasesToRestore: 'لم يتم العثور على اشتراك نشط للاستعادة. إذا كنت تعتقد أن هذا خطأ، يرجى الاتصال بالدعم.',
  purchaseFailed: 'فشلت عملية الشراء. يرجى المحاولة مرة أخرى.',
  restoreFailed: 'فشلت استعادة المشتريات.',
  noActiveSubscription: 'لم يتم العثور على اشتراك نشط للاستعادة.',
  iapNotAvailable: 'عمليات الشراء داخل التطبيق غير متاحة.',
  webPurchaseNotSupported: 'عمليات الشراء داخل التطبيق غير متاحة على الويب. يرجى استخدام تطبيق الهاتف.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'اشتراك بريميوم شهري',
  premiumSubscriptionTagline: 'افتح وصولاً غير محدود لجميع المسلسلات والحلقات',
  whatYouGet: 'ماذا ستحصل عليه',

  // Profile subscription information
  profileSubscriptionDescription: 'احصل على وصول غير محدود لجميع المسلسلات الدرامية والحلقات مع اشتراكنا الشهري.',
  profileBenefit1: 'شاهد أي حلقة من مكتبتنا الكاملة',
  profileBenefit2: 'وصول فوري لجميع الحلقات الجديدة',
  profileBenefit3: 'تجربة مشاهدة بدون إعلانات',

  premiumBenefit1: 'وصول غير محدود لجميع المسلسلات الدرامية - شاهد أي حلقة في أي وقت',
  premiumBenefit2: 'مكتبة كاملة من المحتوى الحالي مع مئات الحلقات',
  premiumBenefit3: 'وصول فوري لجميع الحلقات الجديدة فور صدورها',
  premiumBenefit4: 'شاهد أي حلقة بدون قيود أو حدود',
  premiumBenefit5: 'تجربة مشاهدة بدون إعلانات لترفيه متواصل',
  premiumBenefit6: 'بث فيديو عالي الجودة لأفضل تجربة مشاهدة',
  premiumBenefit7: 'الوصول على جميع أجهزتك - الهاتف والتابلت والويب',
  bestValue: 'أفضل قيمة',
  subscriptionIncludes: 'وصول كامل لجميع المحتوى',
  perMonth: '/شهرياً',
  perWeek: '/أسبوعياً',
  startSubscription: 'بدء الاشتراك',
  learnMoreAboutSubscription: 'معرفة المزيد عن الاشتراك',

  // Subscription terms
  subscriptionTerms: 'سيتم خصم المبلغ من حسابك بالسعر المعروض على شاشة الاشتراك. يتجدد الاشتراك تلقائياً كل شهر ما لم تقم بإلغائه قبل 24 ساعة على الأقل من تاريخ التجديد. يتم خصم الرسوم قبل 24 ساعة من نهاية فترة الفوترة الحالية.',

  // Subscription details modal
  subscriptionDetails: 'تفاصيل الاشتراك',
  whatIsIncluded: 'ما هو مشمول',
  subscriptionDetailsDescription: 'يمنحك اشتراكك الشهري بريميوم وصولاً غير محدود لجميع المسلسلات الدرامية والحلقات في مكتبتنا. يشمل ذلك جميع المحتوى الحالي وجميع الحلقات الجديدة المنشورة خلال فترة اشتراكك. يمكنك مشاهدة أي حلقة في أي وقت على أي من أجهزتك بدون قيود.',
  howBillingWorks: 'كيف تعمل الفوترة',
  billingDescription: 'سيتم خصم المبلغ من حسابك بالسعر المعروض على شاشة الاشتراك. يتجدد الاشتراك تلقائياً كل شهر ما لم تقم بإلغائه قبل 24 ساعة على الأقل من تاريخ التجديد. يتم خصم الرسوم قبل 24 ساعة من نهاية فترة الفوترة الحالية.',
  howToCancel: 'كيفية الإلغاء',
  cancellationDescription: 'يمكنك إلغاء اشتراكك في أي وقت عبر الوصول إلى إعدادات جهازك. لنظام iOS: الإعدادات > [اسمك] > الاشتراكات. لنظام Android: متجر Google Play > القائمة > الاشتراكات. اختر هذا التطبيق واضغط على إلغاء الاشتراك. يبقى اشتراكك نشطاً حتى نهاية فترة الفوترة الحالية.',
  cancellationDescriptionIos: 'يمكنك إلغاء اشتراكك في أي وقت عبر الوصول إلى إعدادات جهازك. لنظام iOS: الإعدادات > [اسمك] > الاشتراكات. اختر هذا التطبيق واضغط على إلغاء الاشتراك. يبقى اشتراكك نشطاً حتى نهاية فترة الفوترة الحالية.',
  cancellationDescriptionAndroid: 'يمكنك إلغاء اشتراكك في أي وقت عبر الوصول إلى إعدادات جهازك. لنظام Android: متجر Google Play > القائمة > الاشتراكات. اختر هذا التطبيق واضغط على إلغاء الاشتراك. يبقى اشتراكك نشطاً حتى نهاية فترة الفوترة الحالية.',
  subscriptionExpiry: 'ماذا يحدث عند انتهاء الاشتراك',
  expiryDescription: 'إذا قمت بالإلغاء أو انتهى اشتراكك، ستفقد الوصول إلى المحتوى المميز. ومع ذلك، سيتم حفظ سجل المشاهدة والمفضلة. يمكنك إعادة الاشتراك في أي وقت لاستعادة الوصول الكامل لجميع الحلقات المميزة.',
  deviceCompatibility: 'توافق الأجهزة',
  compatibilityDescription: 'يعمل اشتراكك على جميع المنصات التي تستخدم فيها نفس الحساب. سجل الدخول بنفس الحساب على أي جهاز للوصول إلى مزايا بريميوم الخاصة بك.',
  helpFeedback: 'المساعدة والتعليقات',
  language: 'اللغة',
  notifications: 'الإشعارات',
  notificationSettings: 'إعدادات الإشعارات',
  pushNotifications: 'الإشعارات الفورية',
  enabled: 'مفعّل',
  disabled: 'معطّل',
  enable: 'تفعيل',
  enabling: 'جاري التفعيل...',
  pushNotificationsEnabled: 'تم تفعيل الإشعارات الفورية بنجاح',
  pushNotificationsDisabled: 'تم تعطيل الإشعارات الفورية',
  enablePushNotificationsInSettings: 'لتلقي الإشعارات، يرجى تفعيلها في إعدادات جهازك.',
  openSettings: 'فتح الإعدادات',
  pushNotificationsEnabledDescription: 'ستتلقى إشعارات على هذا الجهاز',
  pushNotificationsDisabledDescription: 'فعّل الإشعارات للبقاء على اطلاع',
  notificationCategories: 'فئات الإشعارات',
  notificationCategoriesDescription: 'اختر أنواع الإشعارات التي ترغب في تلقيها',
  newEpisodes: 'حلقات جديدة',
  newEpisodesDescription: 'كن أول من يعلم عند صدور حلقات جديدة',
  recommendations: 'التوصيات',
  recommendationsDescription: 'اقتراحات محتوى مخصصة لك',
  subscriptionReminders: 'تذكيرات الاشتراك',
  subscriptionRemindersDescription: 'تذكيرات بخصوص حالة اشتراكك',
  rewardsNotifications: 'المكافآت والإنجازات',
  rewardsNotificationsDescription: 'تحديثات حول مكافآتك وتقدمك',
  marketingNotifications: 'التسويق والعروض الترويجية',
  marketingNotificationsDescription: 'عروض خاصة ومحتوى ترويجي',
  failedToUpdatePreferences: 'فشل في تحديث تفضيلات الإشعارات',
  failedToRequestPermission: 'فشل في طلب إذن الإشعارات',
  signInToSavePreferences: 'سجل الدخول لحفظ تفضيلات الإشعارات على جميع أجهزتك',
  done: 'تم',
  contactUs: 'اتصل بنا',
  settings: 'الإعدادات',
  privacyPolicy: 'سياسة الخصوصية',
  privacySettings: 'الخصوصية والموافقة',
  cookieSettings: 'إعدادات ملفات تعريف الارتباط',
  localStorage: 'التخزين المحلي',
  termsConditions: 'الشروط والأحكام',
  legalNotice: 'الإشعار القانوني',
  pricingConditions: 'شروط التسعير',
  unsubscribe: 'إلغاء الاشتراك',
  unsubscribeInfo: 'معلومات إلغاء الاشتراك',
  loadingUnsubscribeInfo: 'جاري تحميل معلومات إلغاء الاشتراك...',
  unsubscribeContentNotAvailable: 'معلومات إلغاء الاشتراك غير متاحة حالياً.',
  dcbUnsubscribeButton: 'إلغاء اشتراكي',
  dcbUnsubscribeConfirmTitle: 'تأكيد',
  dcbUnsubscribeConfirmMessage: 'هل أنت متأكد من رغبتك في إلغاء اشتراكك؟ ستفقد الوصول إلى المحتوى المميز.',
  dcbUnsubscribeSuccess: 'تم إلغاء اشتراكك بنجاح. لم تعد مشتركاً في الخدمة.',
  dcbUnsubscribeError: 'تعذّر إلغاء اشتراكك. يرجى التواصل مع خدمة العملاء للحصول على المساعدة.',
  loadingPrivacyPolicy: 'جاري تحميل سياسة الخصوصية...',
  privacyPolicyNotAvailable: 'سياسة الخصوصية غير متاحة حالياً.',
  loadingTermsConditions: 'جاري تحميل الشروط والأحكام...',
  termsConditionsNotAvailable: 'الشروط والأحكام غير متاحة حالياً.',
  cookies: 'ملفات تعريف الارتباط',
  cookiesSection: 'ملفات تعريف الارتباط',
  legalSection: 'المعلومات القانونية',
  loadingCookies: 'جاري تحميل معلومات ملفات تعريف الارتباط...',
  cookiesNotAvailable: 'معلومات ملفات تعريف الارتباط غير متاحة حالياً.',
  loadingLegalNotice: 'جاري تحميل الإشعار القانوني...',
  legalNoticeNotAvailable: 'الإشعار القانوني غير متاح حالياً.',
  loadingPricingConditions: 'جاري تحميل شروط التسعير...',
  pricingConditionsNotAvailable: 'شروط التسعير غير متاحة حالياً.',
  retry: 'إعادة المحاولة',
  noEmailApp: 'لا يوجد تطبيق بريد إلكتروني متاح على هذا الجهاز.',
  errorOpeningEmail: 'تعذر فتح تطبيق البريد الإلكتروني.',
  errorOpeningSettings: 'تعذر فتح إعدادات النظام.',
  security: 'الأمان',

  // Loading and errors
  loading: 'جاري التحميل...',
  loadingContent: 'جاري تحميل المحتوى...',
  preparingVideo: 'جاري تحضير الفيديو...',

  seasonNotFound: 'لم يتم العثور على الموسم',
  episodeNotFound: 'لم يتم العثور على الحلقة',
  rubriqueNotFound: 'لم يتم العثور على القسم',

  // Video player

  loadingVideo: 'جاري تحميل الفيديو...',
  loadingPlayer: 'جاري تحميل المشغل...',
  loadingEpisodes: 'جاري تحميل الحلقات...',

  // Badges and labels
  min: 'دقيقة',
  enemiesToLovers: 'من الأعداء إلى العشاق',

  // Actions
  cancel: 'إلغاء',
  delete: 'حذف',
  remove: 'إزالة',
  removeFromList: 'إزالة من المفضلة',
  subscribe: 'اشتراك',
  selectLanguage: 'اختر اللغة',
  restartRequired: 'إعادة التشغيل مطلوبة',
  restartMessage: 'يرجى إعادة تشغيل التطبيق لتطبيق اتجاه التخطيط الجديد.',
  restartToApplyLanguage: 'هل تريد إعادة تشغيل التطبيق لتطبيق اللغة الجديدة؟',
  ok: 'حسناً',
  save: 'حفظ',
  saving: 'جاري الحفظ...',
  editProfile: 'تعديل الملف الشخصي',
  pseudo: 'الاسم المستعار',
  enterPseudo: 'أدخل اسمك المستعار',
  pseudoPlaceholder: 'اختر اسماً فريداً (16 حرف كحد أقصى)',
  pseudoTaken: 'هذا الاسم المستعار مستخدم بالفعل',
  pseudoInvalid: 'هذا الاسم المستعار يحتوي على محتوى غير لائق',
  pseudoInvalidCharacters: 'هذا الاسم المستعار يحتوي على أحرف غير صالحة',
  pseudoNotAccepted: 'يرجى اختيار اسم مستعار آخر، هذا الاسم غير مقبول',
  pseudoMaxLength: 'يجب أن يحتوي الاسم المستعار على 16 حرف كحد أقصى',
  pseudoCharactersCount: '{{count}}/16 حرف',
  editPseudo: 'تعديل الاسم المستعار',
  pseudoUpdated: 'تم تحديث الاسم المستعار بنجاح',
  subtitles: 'الترجمات',
  off: 'معطّل',
  noSubtitlesAvailable: 'لا توجد ترجمات متاحة',
  playbackSpeed: 'سرعة التشغيل',
  normalSpeed: 'عادي',
  profileInformation: 'معلومات الملف الشخصي',
  dateOfBirth: 'تاريخ الميلاد',
  phoneNumber: 'رقم الهاتف',
  enterPhoneNumber: 'أدخل رقم هاتفك',
  notProvided: 'غير مُدخل',
  dateFormatHint: 'الصيغة: {format} (مثال: {example})',
  dateFormatPattern: 'يوم-شهر-سنة',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'يرجى استخدام الصيغة: {format}',
  invalidDate: 'تاريخ غير صالح',

  // Placeholders and descriptions
  discoverGenre: 'اكتشف',

  // Time and duration
  m: 'م', // Million views abbreviation
  now: 'الآن',
  minuteAbbrev: 'د',
  hourAbbrev: 'س',
  dayAbbrev: 'ي',
  monthAbbrev: 'ش',

  // History and viewing progress
  noViewingHistory: 'لا يوجد سجل مشاهدة',
  episodesWillAppearHere: 'ستظهر الحلقات التي تشاهدها هنا',
  history: 'السجل',
  series: 'المسلسلات',
  noFavoritesYet: 'لا توجد مفضلات حتى الآن',
  addContentToFavorites: 'أضف المسلسلات والحلقات إلى مفضلاتك لرؤيتها هنا',

  // My Purchases
  myPurchases: 'مشترياتي',
  purchased: 'تم الشراء',
  myPurchasesTitle: 'حلقاتك المفتوحة',
  myPurchasesDescription: 'اعثر هنا على جميع الحلقات المميزة التي فتحتها بقطعك النقدية. استمر في المشاهدة لكسب المزيد من القطع!',
  tutorialStep1Title: 'شاهد الحلقات',
  tutorialStep1Description: 'اكسب قطعاً نقدية بمشاهدة المحتوى المجاني على المنصة.',
  tutorialStep2Title: 'اجمع المكافآت',
  tutorialStep2Description: 'أكمل التحديات وسجل الدخول يومياً لكسب المزيد من القطع النقدية.',
  tutorialStep3Title: 'افتح المحتوى المميز',
  tutorialStep3Description: 'استخدم قطعك النقدية لفتح حلقات مميزة حصرية.',
  goToRewards: 'انتقل إلى المكافآت',

  // Gamification notifications
  userSignupNotification: 'مرحباً! لقد ربحت {coins} قطعة نقدية لإنشاء حسابك!',
  dailyVisitNotification: 'لقد ربحت {coins} قطعة نقدية لزيارتك اليومية!',
  emailProvidedNotification: 'لقد ربحت {coins} قطعة نقدية لتقديم بريدك الإلكتروني!',
  msisdnProvidedNotification: 'لقد ربحت {coins} قطعة نقدية لتقديم رقم هاتفك!',
  birthDateProvidedNotification: 'لقد ربحت {coins} قطعة نقدية لتقديم تاريخ ميلادك!',
  completeProfileNotification: 'لقد ربحت {coins} قطعة نقدية لإكمال ملفك الشخصي!',
  pseudoProvidedNotification: 'لقد ربحت {coins} قطعة نقدية لإنشاء اسم مستعار مخصص!',
  selectImageSource: 'اختر مصدر الصورة',
  takePhoto: 'التقاط صورة',
  chooseFromLibrary: 'اختيار من المعرض',
  removeProfilePicture: 'إزالة صورة الملف الشخصي',
  removeProfilePictureConfirm: 'هل أنت متأكد أنك تريد إزالة صورة ملفك الشخصي؟',
  profilePictureUpdated: 'تم تحديث صورة الملف الشخصي بنجاح',
  profilePictureRemoved: 'تم إزالة صورة الملف الشخصي بنجاح',
  failedToPickImage: 'فشل في اختيار الصورة من المعرض',
  failedToTakePhoto: 'فشل في التقاط الصورة',
  failedToUploadImage: 'فشل في تحميل الصورة. يرجى المحاولة مرة أخرى.',
  imageInappropriateContent: 'تحتوي الصورة على محتوى غير لائق',
  failedToUpdateProfilePicture: 'فشل في تحديث صورة الملف الشخصي',
  failedToRemoveProfilePicture: 'فشل في إزالة صورة الملف الشخصي',
  watchEpisodeNotification: 'لقد ربحت {coins} قطعة نقدية لمشاهدة حلقة!',
  watchAdsNotification: 'لقد ربحت {coins} قطعة نقدية لمشاهدة الإعلانات!',
  enableNotificationsNotification: 'لقد ربحت {coins} قطعة نقدية لتفعيل الإشعارات!',
  followSocialNotification: 'لقد ربحت {coins} قطعة نقدية لمتابعتنا على وسائل التواصل الاجتماعي!',
  coinsEarnedNotification: 'لقد ربحت {coins} قطعة نقدية!',
  coinsUsedForPremiumNotification: 'لقد استخدمت {coins} قطعة نقدية لفتح هذه الحلقة المميزة!',
  firstCoinsUsageNotification: 'مرحباً! لقد فتحت للتو أول حلقة مميزة لك بالقطع النقدية!',

  // Reward Center
  rewardCenter: 'مركز المكافآت',
  rewards: 'المكافآت',
  weeklyRanking: 'الترتيب الأسبوعي',
  hallOfFame: 'قاعة الشهرة',
  thisWeeksTopPlayers: 'أفضل اللاعبين هذا الأسبوع',
  allTimeChampions: 'أبطال كل الأوقات',
  totalCoinsAllTime: 'إجمالي القطع النقدية',
  coinsThisWeek: 'قطع نقدية هذا الأسبوع',
  achievements: 'إنجازات',
  dayStreakRecord: 'أطول سلسلة أيام',
  you: 'أنت',
  noRankingData: 'لا توجد بيانات ترتيب متاحة',
  checkBackLaterRanking: 'عد لاحقاً للترتيبات الأسبوعية',
  noHallOfFameData: 'لا توجد بيانات قاعة الشهرة متاحة',
  checkBackLaterHallOfFame: 'عد لاحقاً لترتيبات كل الأوقات',
  coins: 'قطع نقدية',
  days: 'أيام',
  dailyCheckIn: 'تسجيل الدخول اليومي',
  earnRewards: 'اكسب المكافآت',
  completed: 'مكتمل',
  claim: 'استلام',
  comingSoon: 'قريباً',
  day: 'يوم',
  today: 'اليوم',
  totalCoins: 'إجمالي القطع النقدية',
  getCoins: 'احصل على قطع نقدية',
  keepWatching: 'واصل المشاهدة',
  dayStreak: 'سلسلة الأيام',
  nextReward: 'المكافأة التالية',
  availableTomorrow: 'متاح غداً',
  weekProgress: 'تقدم الأسبوع',
  serie: 'سلسلة',
  won: 'فاز',
  tomorrow: 'غداً',
  toDo: 'للقيام به',
  firstWeek: 'الأسبوع الأول',
  secondWeek: 'الأسبوع الثاني',
  amazingStreak: 'سلسلة مذهلة! استمر هكذا!',
  overallProgress: 'التقدم العام',
  of: 'من',
  eventsCompleted: 'أحداث مكتملة',
  ofMissionsCompleted: 'من المهام المنجزة',

  // Gamification event categories
  gamificationCategoryUser: 'المستخدم',
  gamificationCategoryProfile: 'الملف الشخصي',
  gamificationCategoryContent: 'المحتوى',
  gamificationCategoryGeneral: 'عام',
  gamificationCategoryDailyMission: 'مهمة يومية',
  gamificationCategoryWelcomeMissions: 'مهام الترحيب',
  gamificationCategoryWatchMissions: 'مهام المشاهدة',
  gamificationCategoryOnceAYear: 'مرة في السنة',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'أكمل المهام واكسب قطعك النقدية!',
  gamificationFeature1Title: 'أنشئ حسابك',
  gamificationFeature1Desc: 'احصل على {{coins}} قطعة نقدية ترحيبية عند التسجيل',
  gamificationFeature2Title: 'شاهد الحلقات',
  gamificationFeature2Desc: 'اكسب {{coins}} قطعة نقدية عند إكمال كل حلقة',
  gamificationFeature3Title: 'تسلق الترتيب',
  gamificationFeature3Desc: 'قارن نفسك بالأعضاء الآخرين كل أسبوع',
  gamificationFeature4Title: 'افتح الحلقات المميزة',
  gamificationFeature4Desc: 'استخدم قطعك النقدية لمشاهدة المزيد من الحلقات',
  gamificationBonusText: '+{{coins}} قطعة نقدية مجانية عند التسجيل!',
  createAccount: 'إنشاء حسابي',
  connectToYou: 'سجل الدخول',

  // All Episodes Control
  allEpisodes: 'جميع الحلقات',
  watchNow: 'شاهد الآن',
  previousEpisode: 'السابق',
  nextEpisode: 'التالي',

  // App availability
  appNotAvailable: 'هذا التطبيق غير متاح بعد في بلدك ولغتك.',
  appNotAvailableSubtext: 'نعمل على توسيع خدمتنا لمزيد من المناطق.',

  // Biometric authentication
  biometricLogin: 'تسجيل الدخول البيومتري',
  signInWithBiometric: 'تسجيل الدخول بالبصمة',
  signInWithWebAuthn: 'تسجيل الدخول بـ WebAuthn',
  signInWithFaceId: 'تسجيل الدخول بـ Face ID',
  signInWithTouchId: 'تسجيل الدخول بـ Touch ID',
  enableBiometric: 'تفعيل تسجيل الدخول البيومتري',
  disableBiometric: 'تعطيل تسجيل الدخول البيومتري',
  biometricNotAvailable: 'المصادقة البيومترية غير متاحة على هذا الجهاز',
  biometricAuthFailed: 'فشلت المصادقة البيومترية',
  biometricDataMissing: 'بيانات تسجيل الدخول البيومتري مفقودة. يرجى تسجيل الدخول باستخدام OTP، ثم إعادة تفعيل تسجيل الدخول البيومتري في إعدادات ملفك الشخصي.',
  biometricNoUserData: 'يرجى تسجيل الدخول أولاً، ثم تفعيل تسجيل الدخول البيومتري في إعدادات ملفك الشخصي.',
  biometricUnexpectedError: 'حدث خطأ غير متوقع. يرجى تسجيل الدخول باستخدام OTP، ثم إعادة تفعيل تسجيل الدخول البيومتري في إعدادات ملفك الشخصي.',
  biometricAuthCancelled: 'تم إلغاء المصادقة البيومترية. يرجى المحاولة مرة أخرى.',
  webauthnNotEnabled: 'يرجى تسجيل الدخول أولاً، ثم تفعيل تسجيل الدخول بـ WebAuthn في إعدادات ملفك الشخصي.',
  webauthnCancelled: 'تم إلغاء مصادقة WebAuthn. يرجى المحاولة مرة أخرى.',
  webauthnFailed: 'فشلت مصادقة WebAuthn',
  biometricLoginEnabled: 'تم تفعيل تسجيل الدخول البيومتري',
  biometricLoginDisabled: 'تم تعطيل تسجيل الدخول البيومتري',
  webauthnLoginEnabled: 'تم تفعيل تسجيل الدخول بـ WebAuthn',
  webauthnLoginDisabled: 'تم تعطيل تسجيل الدخول بـ WebAuthn',
  // iOS-specific labels (use branded terminology)
  faceIdLoginEnabled: 'تم تفعيل تسجيل الدخول بـ Face ID',
  faceIdLoginDisabled: 'تم تعطيل تسجيل الدخول بـ Face ID',
  touchIdLoginEnabled: 'تم تفعيل تسجيل الدخول بـ Touch ID',
  touchIdLoginDisabled: 'تم تعطيل تسجيل الدخول بـ Touch ID',
  // Android-specific labels (use generic biometric terminology)
  androidBiometricLoginEnabled: 'تم تفعيل تسجيل الدخول البيومتري',
  androidBiometricLoginDisabled: 'تم تعطيل تسجيل الدخول البيومتري',
  failedToEnableBiometric: 'فشل في تفعيل تسجيل الدخول البيومتري',
  failedToDisableBiometric: 'فشل في تعطيل تسجيل الدخول البيومتري',
  failedToEnableWebauthn: 'فشل في تفعيل تسجيل الدخول بـ WebAuthn',
  failedToDisableWebauthn: 'فشل في تعطيل تسجيل الدخول بـ WebAuthn',
  success: 'نجاح',
  enableBiometricPrompt: 'هل تريد تفعيل المصادقة البيومترية لتسجيل دخول أسرع في المرة القادمة؟',
  enableBiometricPromptIos: 'هل تريد تفعيل {authType} لتسجيل دخول أسرع في المرة القادمة؟',
  'Enable {{authType}}?': 'تفعيل {{authType}}؟',
  'Would you like to enable {{authType}} for faster login?': 'هل تريد تفعيل {{authType}} لتسجيل دخول أسرع؟',
  '{{authType}} login has been enabled!': 'تم تفعيل تسجيل الدخول بـ {{authType}}!',
  'Failed to enable {{authType}} login. Please try again later.': 'فشل في تفعيل تسجيل الدخول بـ {{authType}}. يرجى المحاولة لاحقاً.',
  biometricLoginTitle: 'تسجيل الدخول البيومتري',
  faceIdLogin: 'تسجيل الدخول بـ Face ID',
  touchIdLogin: 'تسجيل الدخول بـ Touch ID',
  useBiometricToSignIn: 'استخدم البصمة أو فتح القفل بالوجه لتسجيل الدخول بسرعة',
  enableBiometricForSignIn: 'فعّل البصمة أو فتح القفل بالوجه لتسجيل دخول سريع',
  useFaceIdToSignIn: 'استخدم Face ID لتسجيل الدخول بسرعة',
  enableFaceIdForSignIn: 'فعّل Face ID لتسجيل دخول سريع',
  useTouchIdToSignIn: 'استخدم Touch ID لتسجيل الدخول بسرعة',
  enableTouchIdForSignIn: 'فعّل Touch ID لتسجيل دخول سريع',

  // Delete account
  deleteMyAccount: 'حذف حسابي',
  deleteAccountConfirmation: 'تأكيد الحذف',
  deleteAccountWarningNotSubscribed: 'سنقوم بحذف حسابك. لن تتمكن من الوصول إلى Hekaya بعد التأكيد.\n\nومع ذلك، يرجى ملاحظة أنه وفقاً للوائح، نحتفظ ببعض البيانات بشكل آمن، مثلاً لأغراض حل النزاعات المحتملة.',
  deleteAccountWarningSubscribed: 'لديك حالياً اشتراك نشط. يرجى إلغاؤه أولاً. ستجد طرق إلغاء الاشتراك في "حسابي"، "إلغاء الاشتراك". بمجرد إلغاء الاشتراك، يمكنك متابعة حذف حسابك.\n\nسنقوم بحذف حسابك. لن تتمكن من الوصول إلى Hekaya بعد التأكيد.\n\nومع ذلك، يرجى ملاحظة أنه وفقاً للوائح، نحتفظ ببعض البيانات بشكل آمن، مثلاً لأغراض حل النزاعات المحتملة.',
  iConfirm: 'أؤكد',
  deletingAccount: 'جاري حذف الحساب...',
  accountDeleted: 'تم حذف الحساب',
  accountDeletedSuccess: 'تم حذف حسابك بنجاح',
  accountDeleteError: 'خطأ في حذف الحساب',
  activeSubscriptionErrorTitle: 'اشتراك نشط',
  activeSubscriptionErrorMessage: 'يجب عليك إلغاء اشتراكك قبل أن تتمكن من حذف حسابك.',
  gracePeriodErrorTitle: 'الحذف غير متاح حاليا',
  gracePeriodErrorMessage: 'تم إلغاء اشتراكك، لكنه لا يزال نشطا حتى تاريخ انتهائه. ستتمكن من حذف حسابك بمجرد انتهاء هذه الفترة.',
  gracePeriodBannerTitle: 'تم إلغاء الاشتراك',
  gracePeriodBannerMessage: 'تم إلغاء اشتراكك لكنه يبقى نشطا حتى {{date}}. تحتفظ بالوصول إلى جميع المحتوى المميز حتى ذلك الحين.',
  notBilledDenyBannerTitle: 'الاشتراك موقوف',
  notBilledDenyBannerMessage: 'تم تعليق اشتراكك مؤقتا بسبب مشكلة في الدفع. لاستعادة الوصول إلى خدمتنا، يرجى شحن حسابك *9. سيتم إعادة تفعيل حساب Hekaya الخاص بك بمجرد معالجة الدفع.',

  // Network connection
  noInternetConnection: 'لا يوجد اتصال بالإنترنت. يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
  noInternetConnectionShort: 'لا يوجد اتصال بالإنترنت',
  checkInternetConnection: 'يرجى التحقق من اتصالك بالإنترنت',
  connectionRequired: 'الاتصال بالإنترنت مطلوب',
  dismiss: 'متابعة بدون اتصال',
  slowNetworkDetected: 'تم اكتشاف شبكة بطيئة',
  poorNetworkConnection: 'اتصال الشبكة لديك يواجه مشاكل. يستغرق تحميل الفيديو وقتاً أطول من المعتاد.',
  loadingTime: 'وقت التحميل',
  slowConnection: 'اتصال بطيء',

  // Image Cache Storage
  imageCacheStorage: 'تخزين ذاكرة الصور',
  cachedImages: 'الصور المخزنة',
  storageUsed: 'المساحة المستخدمة',
  expiredImages: 'الصور منتهية الصلاحية',
  clearExpiredCache: 'مسح المنتهية',
  clearAllCache: 'مسح الكل',
  clearing: 'جاري المسح...',
  clearImageCache: 'مسح ذاكرة الصور',
  clearImageCacheConfirmation: 'هل أنت متأكد أنك تريد مسح جميع الصور المخزنة؟ سيؤدي هذا إلى تحرير مساحة التخزين ولكن ستحتاج الصور إلى التنزيل مرة أخرى.',
  clearCache: 'مسح الذاكرة',
  cacheCleared: 'تم مسح الذاكرة بنجاح! تم حذف {{count}} صورة.',
  expiredCacheCleared: 'تم مسح الذاكرة المنتهية! تم حذف {{count}} صورة منتهية الصلاحية.',
  noExpiredCache: 'لا توجد صور منتهية الصلاحية للمسح.',
  failedToClearCache: 'فشل في مسح الذاكرة. يرجى المحاولة مرة أخرى.',
  cacheAutoClears30Days: 'يتم مسح الصور تلقائياً بعد 30 يوماً',
  info: 'معلومات',

  // App version
  version: 'الإصدار',

  // Pagination
  scrollForMore: 'مرر للمزيد',
  noMoreContent: 'نهاية القائمة',
  loadingMore: 'جاري التحميل...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'سجّل الدخول أو أنشئ حسابًا مجانًا',
    subscriptionWelcomeTitle: 'شكراً لاشتراكك!',
    subscriptionWelcomeMessage: 'الخطوة الأخيرة: سجّل لإنشاء حساب أو سجّل الدخول إلى حساب موجود لبدء مشاهدة الدراما.',
    emailPlaceholder: 'عنوان البريد الإلكتروني',
    phonePlaceholder: 'رقم الهاتف',
    emailOrPhonePlaceholder: 'البريد الإلكتروني أو رقم الهاتف',
    continue: 'متابعة',
    continueWithGoogle: 'المتابعة مع Google',
    continueWithApple: 'المتابعة مع Apple',
    termsPrefix: 'بالمتابعة، أنت توافق على',
    termsOfService: 'شروط الخدمة',
    privacyPolicy: 'سياسة الخصوصية',
    confirmEmail: 'تأكيد عنوان البريد الإلكتروني',
    confirmYourEmail: 'أكد عنوان بريدك الإلكتروني',
    confirmPhone: 'تأكيد رقم الهاتف',
    confirmYourPhone: 'أكد رقم هاتفك',
    codeSentTo: 'أرسلنا رمزًا إلى',
    codeSentToPhone: 'أرسلنا رمزًا إلى',
    enterCodeBelow: 'أدخله أدناه للتحقق من حسابك.',
    resendCode: 'إعادة إرسال الرمز',
    resendIn: 'إعادة الإرسال خلال',
    verify: 'تحقق',
    connectingInProgress: 'جاري الاتصال...',
    accountCreated: 'تم إنشاء الحساب',
    stayUpdatedTitle: 'هل ترغب في البقاء على اطلاع بآخر الأخبار؟',
  stayUpdatedDescription: 'نود أن نرسل لك عروضًا مخصصة وتوصيات بأحدث المسلسلات وأخبار إصداراتنا الجديدة.',
    learnMore: 'معرفة المزيد',
    subscribe: 'اشترك',
    noThanks: 'لا شكرًا',
    enterEmailOrPhone: 'يرجى إدخال بريدك الإلكتروني أو رقم هاتفك',
    sendFailed: 'فشل في إرسال الرمز. يرجى المحاولة مرة أخرى.',
    enterCompleteCode: 'يرجى إدخال الرمز الكامل المكون من 6 أرقام',
    verificationFailed: 'فشل التحقق. يرجى المحاولة مرة أخرى.',
    invalidCode: 'رمز غير صالح. يرجى المحاولة مرة أخرى.',
    codeExpired: 'انتهت صلاحية الرمز. يرجى طلب رمز جديد.',
    checkSpamFolder: 'تذكر التحقق من مجلد البريد العشوائي',
    dcbValidatingSubscription: 'جارٍ التحقق من اشتراكك...',
    dcbActivating: 'جارٍ تفعيل اشتراكك...',
    dcbSuccessTitle: 'تم تفعيل الاشتراك!',
    dcbSuccessMessage: 'تم تفعيل اشتراكك بنجاح. يمكنك الآن الاستمتاع بجميع المحتويات.',
    dcbStartWatching: 'ابدأ المشاهدة',
    dcbErrorTitle: 'خطأ في التفعيل',
    dcbErrorRetry: 'حدث خطأ أثناء تفعيل اشتراكك. يرجى المحاولة مرة أخرى.',
    dcbPaymentNotFound: 'لم يتم العثور على الاشتراك. تحقق من الرابط أو اتصل بالدعم.',
    dcbRetryButton: 'إعادة المحاولة',
    dcbIdentityMismatchPhone: 'رقم الهاتف المستخدم للاشتراك هو {{identifier}}. يرجى استخدام هذا الرقم لإنشاء حسابك.',
    dcbIdentityMismatchEmail: 'البريد الإلكتروني المستخدم للاشتراك هو {{identifier}}. يرجى استخدام هذا البريد لإنشاء حسابك.',
    dcbRecoveryBanner: 'تم اكتشاف اشتراك معلق. أنشئ حسابك للوصول إليه.',
    dcbAlreadySubscribed: 'مشترك بالفعل عبر الدفع بالهاتف؟',
    dcbEnterPhone: 'أدخل رقم الهاتف المستخدم أثناء الدفع:',
    dcbRecoverButton: 'استرداد',
    dcbMsisdnNotFound: 'لم يتم العثور على اشتراك معلق لهذا الرقم.',
    dcbMsisdnRecoveryFailed: 'فشل الاسترداد. يرجى المحاولة مرة أخرى.',
    invalidPhoneNumber: 'رقم هاتف غير صالح.',
  },
  and: 'و',
  smartBannerSubtitle: 'تجربة أفضل في التطبيق',
  smartBannerOpen: 'فتح',
  paymentVerifying: 'جاري التحقق من اشتراكك...',
  paymentSuccessTitle: 'تم تفعيل الاشتراك!',
  paymentSuccessMessage: 'تهانينا، لديك الآن حق الوصول إلى جميع المحتوى المميز.',
  paymentSuccessButton: 'ابدأ المشاهدة',
  paymentPendingMessage: 'تم استلام دفعتك. سيكون اشتراكك نشطًا في غضون لحظات.',
  paymentRefreshButton: 'تحديث',
  redirectingToPayment: 'جاري التوجيه إلى صفحة الدفع...',
  webPaymentIframeErrorTitle: 'صفحة الدفع غير متاحة',
  webPaymentIframeErrorMessage: 'تعذر تحميل صفحة الدفع في التطبيق. يمكنك فتحها في علامة تبويب جديدة.',
  webPaymentOpenExternal: 'فتح في علامة تبويب جديدة',

  // Premium subscription card
  enterPremiumExperience: 'ادخل تجربة',
  popular: 'شائع',
  mobileInvoice: 'فاتورة الهاتف',
  mobileInvoicePrice: '€9.99/شهرياً',
  mobileInvoiceDescription: 'الدفع عبر فاتورة هاتفك. بسيط وسريع.',
  cardAppleGooglePay: 'بطاقة / Apple Pay / Google Pay',
  cardPaymentDescription: 'دفع آمن بالبطاقة أو Apple Pay أو Google Pay.',
  dcbPaymentOfferDescription: 'الدفع عبر فاتورة هاتفك. بسيط وسريع.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'يتم إصدار فاتورة الاشتراك وإدارته عبر حسابك في Apple App Store.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'يتم إصدار فاتورة الاشتراك وإدارته عبر حسابك في Google Play Store.',
  upgradeToPremium: 'الترقية إلى بريميوم',
  cancelAnytimeNoCommitment: 'إلغاء في أي وقت · بدون التزام',
  whyBecomeVip: 'لماذا تصبح VIP؟',
  joinPremiumCommunity: 'انضم إلى مجتمع Hekaya المميز',
  unlimitedAccessShort: 'وصول غير محدود لجميع المسلسلات والحلقات.\nشاهد متى تريد، أينما تريد.',
};
